import sortPickerItemsAlphabetically from '@angular/dashboard/manage/helpers/sortPickerItemsAlphabetically';

import positionsTableUrl from '../positions/positions-table.html';
import { groupTexts } from '../constants';
import config from '../../../config';

import indexUrl from './index.html';

class ManagePositionsCtrl {
  positionsTableUrl = positionsTableUrl;
  ARCHIVING_LOCATIONS_POSITIONS_ENABLED = config.ARCHIVING_LOCATIONS_POSITIONS_ENABLED;
  DELETING_PERSONAS_ENABLED = config.DELETING_PERSONAS_ENABLED;
  isPositionMergeModalOpened = false;
  mergeModalFromItems = [];

  constructor(
    PersonaCollection,
    ConfirmService,
    Restangular,
    RestUtils,
    Authentication,
    AlertService,
    Utils,
    UserUtils,
    GroupsService,
    IntegrationsEducation,
    TabsControl,
    toDateMediumFilter,
    uppercaseFirstFilter,
    filterFilter,
    pluralizeFilter,
    displayNumberFilter,
    $state,
    $parse,
    $document,
    $uibModal
  ) {
    'ngInject';

    Object.assign(this, {
      PersonaCollection,
      ConfirmService,
      Restangular,
      RestUtils,
      Authentication,
      AlertService,
      Utils,
      UserUtils,
      GroupsService,
      IntegrationsEducation,
      TabsControl,
      toDateMediumFilter,
      uppercaseFirstFilter,
      filterFilter,
      pluralizeFilter,
      displayNumberFilter,
      $state,
      $parse,
      $document,
      $uibModal,
    });

    this.Utils = Utils;
    this.toDateMediumFilter = toDateMediumFilter;
    this.$document = $document;
    this.emptyLabel = '-';
    this.groupType = 'position';
    this.cancelCounter = 0;
    this.saveCounter = 0;
    this.wagesToSave = {};
    this.positionGroups = Authentication.user.isManager
      ? ['regularPositions', 'archivedPositions']
      : ['positions'];
  }

  $onInit() {
    this.today = this.Utils.getNowDate();
    this.updateCurrentWages();
    this.$document.on('keypress', this.enterClickListener);

    setTimeout(
      () =>
        this.IntegrationsEducation.showStep(
          'toast',
          this.IntegrationsEducation.stepTypes.positions
        ),
      1000
    );

    // TODO there might be a better place to call it, especially that
    // it needs to be called ad hoc when position is archived through  UI
    this.setTabs();
  }

  $onDestroy() {
    this.$document.off('keypress', this.enterClickListener);
    this.tabsControl?.destroy();
  }

  setTabs() {
    this.tabs =
      this.Authentication.user.isManager && this.includeArchived
        ? [
            { value: 'positions', label: 'Positions' },
            {
              value: 'archived',
              label: 'Archived',
              show: () => !!this.PersonaCollection.archivedPositions.length,
            },
          ]
        : [{ value: 'positions', label: '' }];

    if (this.tabs.length <= 1) {
      return;
    }

    this.tabsControl = new this.TabsControl(this.tabs, this.tabs[0].value);
  }

  get activeTab() {
    return this.tabsControl?.activeTab?.value;
  }

  changeTab(value) {
    if (value === this.tabsControl.activeTab.value) {
      return;
    }

    const tab = this.tabs.find((t) => t.value === value);
    this.tabsControl.changeTab(tab);
  }

  getTabTitle() {
    const positionCountDict = {
      positions: {
        number: this.positions?.length,
        title: 'Position',
      },
      archived: {
        number: this.PersonaCollection.archivedPositions?.length,
        title: 'Archived position',
      },
    };

    const titleGroup = positionCountDict[this.activeTab] || positionCountDict.positions;
    const suffix = titleGroup.number !== 1 ? 's' : '';

    return `${titleGroup.number} ${titleGroup.title}${suffix}`;
  }

  get selectedGroups() {
    return this.GroupsService.getSelectedGroups(
      this.selectedItemIds,
      this.visibleItemsDict,
      this.canDeleteGroup
    );
  }

  get selectedGroupsToArchive() {
    return this.GroupsService.filterUnarchived(this.selectedGroups);
  }

  get selectedGroupsToUnarchive() {
    return this.GroupsService.filterArchived(this.selectedGroups);
  }

  enterClickListener = (event) => {
    if (event.which === 13 && event.shiftKey === false && this.laborPositionsForm.$dirty) {
      this.submitWageEditing();
      event.preventDefault();
    }
  };

  updateCurrentWages() {
    this.currentWagePerPosition = this.getCurrentWages();
  }

  getCurrentWages() {
    const positionWages = {};

    this.positions.forEach((position) => {
      let currentWage;
      let effectiveDate;

      position.wages.forEach((wage) => {
        if (wage.fromDate <= this.today && (!effectiveDate || effectiveDate < wage.fromDate)) {
          currentWage = wage;
        }
      });

      positionWages[position.id] = currentWage;
    });

    return positionWages;
  }

  updateWage(wage, positionId) {
    const currentWage = this.currentWagePerPosition[positionId];

    if (!currentWage) {
      this.wagesToSave[positionId] = {
        regularRate: wage,
        fromDate: this.today,
        positionId,
      };
    } else if (currentWage.regularRate !== wage) {
      if (this.Utils.formatDate(currentWage.fromDate) === this.Utils.formatDate()) {
        this.wagesToSave[positionId] = {
          ...currentWage,
          regularRate: wage,
        };
      } else {
        this.wagesToSave[positionId] = {
          id: currentWage.id,
          regularRate: wage,
          fromDate: this.today,
          positionId,
        };
      }
    }
  }

  mapPositionToMergeModalItem = (position) => ({
    id: position.id,
    label: position.name,
    color: position.color,
    sub: `${position.activeMembers.length} ${
      position.activeMembers.length === 1 ? 'Employee' : 'Employees'
    }`,
  });

  openPositionMergeModal(positions) {
    if (!positions.length) {
      return;
    }

    if (this.selectedGroupsToUnarchive?.length) {
      return;
    }

    this.isPositionMergeModalOpened = true;
    this.mergeModalFromItems = positions.map(this.mapPositionToMergeModalItem);
    this.mergeModalAvailableItems = sortPickerItemsAlphabetically(
      this.positions.map(this.mapPositionToMergeModalItem)
    );
  }

  onPositionMergeModalClose(step) {
    this.mergeModalFromItems = null;
    this.mergeModalAvailableItems = null;
    this.isPositionMergeModalOpened = false;

    if (step === 2) {
      this.selectedItemIds = Object.create(null);
    }
  }

  onPositionMergeModalSubmit() {
    this.isPositionMergeModalOpened = false;
  }

  cancelWageEditing() {
    this.laborPositionsForm.$setPristine();
    this.cancelCounter++;
    this.wagesToSave = {};
  }

  async submitWageEditing() {
    if (this.laborPositionsForm.$invalid) {
      this.laborPositionsForm.$setSubmitted();
      throw 'Form invalid';
    }

    this.saveCounter++;

    const positionIds = Object.keys(this.wagesToSave);
    if (!positionIds.length) {
      return false;
    }

    const promises = positionIds.reduce((acc, positionId) => {
      const positionWage = this.wagesToSave[positionId];
      if (positionWage.regularRate === '') {
        positionWage.deleted = true;
        positionWage.regularRate = 0;
      }

      const positionPlain = this.positions.find((pos) => pos.id === Number(positionId));

      return [
        ...acc,
        this.Restangular.all('labor/wages/position/bulk').customPUT([positionWage]),
        this.Restangular.restangularizeElement(null, positionPlain, 'groups')
          .withHttpConfig()
          .put(),
      ];
    }, []);

    if (promises.length) {
      await Promise.all(promises);
      this.updateCurrentWages();
      this.displaySuccessMessage(promises.length);
      this.wagesToSave = {};
    }

    this.laborPositionsForm.$setPristine();
  }

  displaySuccessMessage(count) {
    const displayDate = this.toDateMediumFilter(this.today);
    if (count > 1) {
      this.AlertService.success(
        `Updated wages are effective from ${displayDate}\nYou can modify dates under Options`
      );
    } else {
      this.AlertService.success(
        `Updated wage is effective from ${displayDate}\nYou can modify date under Options`
      );
    }
  }

  get positions() {
    if (this.displayMyGroups) {
      return this.PersonaCollection.me.positions;
    }

    return this.PersonaCollection.positions;
  }

  get selectedItemIds() {
    return this.positionGroups.reduce(
      (acc, positionGroup) => ({ ...acc, ...this[`selectedItemIds-${positionGroup}`] }),
      {}
    );
  }

  set selectedItemIds(val) {
    if (Object.keys(val).length) {
      throw 'Cannot set selectedItemIds to a non-empty object';
    }

    if (this.positionGroups) {
      this.positionGroups.forEach((positionGroup) => {
        this[`selectedItemIds-${positionGroup}`] = Object.create(null);
      });
    }
  }

  get isSomethingSelected() {
    return this.positionGroups.some((g) => this[`isSomethingSelected-${g}`]);
  }

  get visibleItemsDict() {
    return this.positionGroups.reduce(
      (acc, positionGroup) => ({ ...acc, ...this[`visibleItemsDict-${positionGroup}`] }),
      {}
    );
  }

  deleteSelectedPositions() {
    this.ConfirmService.ask(
      {
        question: groupTexts.position.multipleDeletion.title,
        conditions: groupTexts.position.multipleDeletion.conditions,
        title: 'Delete positions',
        confirm: 'Delete',
        warning: 'Warning: this cannot be undone.',
        confirmText: groupTexts.position.multipleDeletion.confirmText,
      },
      () => {
        const ids = this.selectedGroups.map((g) => g.id);
        this.Restangular.all('groups')
          .customDELETE(null, { id: ids })
          .then(() => {
            const text = `${ids.length} position${ids.length === 1 ? '' : 's'} deleted`;
            this.AlertService.success(text);
            this.selectedItemIds = Object.create(null);
          });
      }
    ).ignoreCancel();
  }

  async archiveSelectedPositions() {
    await this.GroupsService.archiveGroups(this.selectedGroupsToArchive, 'position');
    this.selectedItemIds = Object.create(null);
  }

  async unarchiveSelectedPositions() {
    await this.GroupsService.unarchiveGroups(this.selectedGroupsToUnarchive, 'position');
    this.selectedItemIds = Object.create(null);
  }

  canDeleteGroup = (groupId) =>
    this.UserUtils.canEditGroup(this.PersonaCollection.personasDict[groupId]);
}

export default {
  controller: ManagePositionsCtrl,
  controllerAs: 'ctrl',
  templateUrl: indexUrl,
  bindings: {
    disableBulkActions: '<?',
    hideHeader: '<?',
    columnSubset: '<?',
    search: '=?',
    includeArchived: '<?',
  },
};
